import { PageEvent } from '@angular/material/paginator';
import { createAction, props } from '@ngrx/store';
import { ReservationStatus, TransitProgram, Trip, VehicleType } from '@uzurv/clara';
import { HttpException } from '@uzurv/core';
import { Tabs } from '../../pages/ride-tracking/ride-tracking.page';
import { RideTrackingState } from './ride-tracking.reducer';

export const Start = createAction('[Ride Tracking] Start');

export const RestoreState = createAction('[Ride Tracking] Restore state', props<{ state: RideTrackingState }>());

export const ChangeTab = createAction('[Ride Tracking] Change tab', props<{ tabs: Tabs }>());

export const GetRides = createAction('[Ride Tracking] Get rides');

export const GetRidesSuccess = createAction('[Ride Tracking] Get rides success', props<{ trips: Array<Trip> }>());

export const GetRidesFail = createAction('[Ride Tracking] Get rides fail', props<{ error: HttpException }>());

export const GetReservationStatusesSuccess = createAction(
  '[Ride Tracking] Get reservation statuses success',
  props<{ reservationStatuses: Array<ReservationStatus> }>()
);

export const GetReservationStatusesFail = createAction('[Ride Tracking] Get reservation statuses fail', props<{ error: HttpException }>());

export const PageRides = createAction('[Ride Tracking] Page rides', props<{ pageEvent: PageEvent }>());

export const SelectTransitPrograms = createAction(
  '[Ride Tracking] Select transit programs',
  props<{ transitPrograms: Array<TransitProgram> }>()
);

export const SelectVehicleTypes = createAction('[Ride Tracking] Select vehicle types', props<{ vehicleTypes: Array<VehicleType> }>());

export const SelectReservationStatuses = createAction(
  '[Ride Tracking] Select reservation statuses',
  props<{ reservationStatuses: Array<ReservationStatus> }>()
);

export const GoToRide = createAction('[Ride Tracking] Go to ride', props<{ trip: Trip }>());
